<style scoped>
/* Ajoute ici le style spécifique au nouveau dashboard */
</style>
<template>
  <div class="text-left">
    <div class="mt-4 mb-0 mb-md-6">
      <div class="d-flex align-center mb-4">
        <div>
          <h1 class="my-2 text-h4 font-weight-black text-uppercase">{{ canteen.name }}</h1>
          <p class="text-body-2 text--secondary mb-0">SIRET : {{ canteen.siret }}</p>
        </div>
      </div>
    </div>

    <div class="mt-6">
      <v-row class="flex-nowrap" style="overflow-x: auto">
        <!-- Carte Lutte contre le gaspillage -->
        <v-col cols="12" md="4" class="d-flex">
          <v-card class="pa-4 h-100 flex-grow-1" outlined>
            <div class="d-flex align-center mb-3">
              <v-icon color="orange" class="mr-2">mdi-food-apple</v-icon>
              <h3 class="text-h6 font-weight-black">Mes diagnostics</h3>
            </div>

            <v-chip color="success" text-color="white" small class="mb-4">Complété</v-chip>

            <p class="text-body-2 mb-4">
              Analyser votre situation, mettre en place des solutions comme la réservation de repas, et valoriser les
              restes par des dons aux associations.
            </p>

            <v-btn
              text
              color="primary"
              class="pa-0 justify-end"
              style="margin-left: auto"
              @click="goToResumeDiagnosticGaspillage"
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card>
        </v-col>

        <!-- Carte actions -->
        <v-col cols="12" md="4" class="d-flex">
          <v-card class="pa-4 h-100 flex-grow-1" outlined>
            <div class="d-flex align-center mb-3">
              <v-icon color="success" class="mr-2">mdi-leaf</v-icon>
              <h3 class="text-h6 font-weight-black">Mes actions nutritions</h3>
            </div>

            <v-chip color="warning" text-color="white" small class="mb-4">Encours</v-chip>

            <p class="text-body-2 mb-4">
              Apprenez à connaitre vos convives pour que leur bien être contribue à une alimentation raison qui réduit
              le gaspillage en amont et en aval de vos cuisines
            </p>

            <v-btn text color="primary" class="pa-0 justify-end" style="margin-left: auto" @click="goToActionPlan">
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card>
        </v-col>
        <!-- Carte teledeclaration -->
        <v-col cols="12" md="4" class="d-flex">
          <v-card class="pa-4 h-100 flex-grow-1" outlined>
            <div class="d-flex align-center mb-3">
              <v-icon color="warning" class="mr-2">mdi-information</v-icon>
              <h3 class="text-h6 font-weight-black">Mes télédéclarations</h3>
            </div>

            <v-chip color="error" text-color="white" small class="mb-4">A faire</v-chip>

            <p class="text-body-2 mb-4">
              Nous transformons les résultats de vos actions en données pour la télédécaltion. Pour rappel, selon
              l’arrêté ministériel du 14 septembre 2022, il est obligatoire de télédéclarer ses achats.
            </p>

            <v-btn
              text
              color="primary"
              class="pa-0 justify-end"
              style="margin-left: auto"
              @click="goToOnlineDeclarationPage"
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <!-- Section graphique gaspillage alimentaire -->
    <div class="mt-8">
      <h2 class="text-h5 font-weight-black mb-4">
        Gaspillage alimentaire&nbsp;: Répartition et valorisation des repas
      </h2>
      <div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 32px; align-items: flex-start">
        <div style="max-width: 400px; min-width: 300px; flex: 1 1 300px">
          <VueApexCharts type="pie" :options="allPieOptions" :series="allPieSeries" height="350" />
        </div>
        <div style="max-width: 500px; min-width: 320px; flex: 1 1 320px">
          <VueApexCharts type="line" :options="lineOptions" :series="lineSeries" height="350" />
        </div>
        <div style="max-width: 500px; min-width: 320px; flex: 1 1 320px">
          <VueApexCharts type="bar" :options="barOptions" :series="barSeries" height="350" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts"

export default {
  name: "CantineNewDashboard",
  components: { VueApexCharts },
  props: {
    canteenId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      canteen: {},
      selectedYear: 2024,
      years: [
        { text: "2024", value: 2024 },
        { text: "2023", value: 2023 },
        { text: "2022", value: 2022 },
        { text: "2021", value: 2021 },
      ],
      bilanStatus: "À télédéclarer",
      cards: [
        {
          title: "Qualité des produits",
          icon: "mdi-apple",
          iconColor: "error",
          status: "Complété",
          description:
            "Composer des repas avec au moins 50 % de produits de qualité et durables, dont 20 % de bio, pour proposer une alimentation plus saine et écologique à vos convives.",
          hasChart: true,
          chartData: [
            { label: "Bio : — %", value: 20, color: "#8B4513" },
            { label: "Durable et de qualité : 0 %", value: 50, color: "#CD853F" },
          ],
        },
        {
          title: "Lutte contre le gaspillage",
          icon: "mdi-food-apple",
          iconColor: "orange",
          status: "Complété",
          description:
            "Analyser votre situation, mettre en place des solutions comme la réservation de repas, et valoriser les restes par des dons aux associations.",
        },
      ],
      // Fusion de toutes les métriques dans un seul graphique
      allPieSeries: [
        1200, // Repas servis
        1600, // Repas préparés
        200, // Repas jetés
        50, // Repas redistribués
        50, // Repas transformés
        100, // Repas non valorisables
      ],
      allPieOptions: {
        labels: [
          "Repas servis",
          "Repas préparés",
          "Repas jetés",
          "Repas redistribués",
          "Repas transformés",
          "Repas non valorisables",
        ],
        colors: [
          "#00A95F", // Servis
          "#F9A825", // Préparés
          "#E53935", // Jetés
          "#1976D2", // Redistribués
          "#43A047", // Transformés
          "#B71C1C", // Non valorisables
        ],
        legend: {
          position: "bottom",
          labels: { colors: "#000" },
        },
        title: {
          text: "Répartition et valorisation des repas (exemple)",
          align: "center",
          style: { color: "#000", textShadow: "1px 1px 2px #000" },
        },
        tooltip: {
          y: {
            formatter(val) {
              return val + " repas"
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: { colors: ["#fff"], fontWeight: "bold", textShadow: "1px 1px 2px #000" },
          dropShadow: {
            enabled: true,
            top: 1,
            left: 1,
            blur: 2,
            color: "#000",
            opacity: 1,
          },
          formatter(val, opts) {
            return opts.w.globals.labels[opts.seriesIndex] + ": " + opts.w.globals.series[opts.seriesIndex]
          },
        },
        labelsStyle: { colors: ["#000"] },
      },
      // Données pour le graphique de type courbe (line chart)
      lineSeries: [
        {
          name: "Tonnes jetées",
          data: [2.1, 2.3, 2.8, 3.5, 3.7], // 2021 à 2025, augmentation entre 2023 et 2025
        },
        {
          name: "Objectifs",
          data: [1.1, 2.0, 2.5, 3.5, 4.0], // 2021 à 2025, augmentation entre 2023 et 2025
        },
      ],
      lineOptions: {
        colors: ["#E53935", "#10A047"], // Couleurs pour les lignes
        chart: {
          id: "alimentation-jete-chart",
          toolbar: { show: false },
        },
        xaxis: {
          categories: [2021, 2022, 2023, 2024, 2025],
          title: { text: "Année", style: { color: "#000", textShadow: "1px 1px 2px #000" } },
          labels: { style: { colors: "#000", textShadow: "1px 1px 2px #000" } },
        },
        yaxis: {
          title: { text: "Tonnes jetées", style: { color: "#000", textShadow: "1px 1px 2px #000" } },
          min: 0,
          labels: { style: { colors: "#000", textShadow: "1px 1px 2px #000" } },
        },
        dataLabels: {
          enabled: true,
          style: { colors: ["#fff"], fontWeight: "bold", textShadow: "1px 1px 2px #000" },
          dropShadow: {
            enabled: true,
            top: 1,
            left: 1,
            blur: 2,
            color: "#000",
            opacity: 1,
          },
          formatter(val) {
            return val + " t"
          },
        },
        title: {
          text: "Évolution des tonnes d'alimentation jetée",
          align: "center",
          style: { color: "#000", textShadow: "1px 1px 2px #000" },
        },
        legend: {
          show: false,
          labels: { colors: "#000" },
        },
      },
      // Données pour l'histogramme coût jeté vs bio
      barSeries: [
        {
          name: "Coût aliments jetés (€)",
          data: [3000, 3300, 3600, 4000, 4100], // 3x, 3.3x, 3.6x, 4x, 4x le bio
        },
        {
          name: "Coût produits bio achetés (€)",
          data: [1000, 1100, 1300, 1200, 1600], // base stable, légère hausse en 2025
        },
      ],
      barOptions: {
        colors: ["#E53935", "#00A010"],
        chart: {
          id: "cout-aliments-bar",
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        xaxis: {
          categories: [2021, 2022, 2023, 2024, 2025],
          title: { text: "Année", style: { color: "#000", textShadow: "1px 1px 2px #000" } },
          labels: { style: { colors: "#000", textShadow: "1px 1px 2px #000" } },
        },
        yaxis: {
          title: { text: "Coût (€)", style: { color: "#000", textShadow: "1px 1px 2px #000" } },
          min: 0,
          labels: { style: { colors: "#000", textShadow: "1px 1px 2px #000" } },
        },
        dataLabels: {
          enabled: true,
          style: { colors: ["#fff"], fontWeight: "bold", textShadow: "1px 1px 2px #000" },
          dropShadow: {
            enabled: true,
            top: 1,
            left: 1,
            blur: 2,
            color: "#000",
            opacity: 1,
          },
          formatter(val) {
            return val + " €"
          },
        },
        legend: {
          position: "bottom",
          labels: { colors: "#000" },
        },
        title: {
          text: "Coût des aliments jetés vs produits bio achetés",
          align: "center",
          style: { color: "#000", textShadow: "1px 1px 2px #000" },
        },
      },
    }
  },
  computed: {
    // Simule un utilisateur connecté
    loggedUser() {
      return {
        firstName: "Directeur",
        isElectedOfficial: false,
        job: "MANAGER",
      }
    },
  },
  mounted() {
    this.loadCanteen()
    console.log("Dashboard loaded for year:", this.selectedYear)
  },
  methods: {
    goToResumeDiagnosticGaspillage() {
      this.$router.push({ name: "WasteDiagnosticResumePage" })
    },
    goToActionPlan() {
      this.$router.push({ name: "ManageResults" })
    },
    goToOnlineDeclarationPage() {
      this.$router.push({ name: "OnlineDeclarationPage" })
    },
    loadCanteen() {
      const id = 1
      return fetch(`/api/v1/publishedCanteens/${id}`)
        .then(async (response) => {
          this.canteen = await response.json()
        })
        .catch(() => {
          this.$router.push({ name: "CanteensHome" }).then(() => {
            this.$store.dispatch("notify", {
              message: "Nous n'avons pas trouvé cette cantine",
              status: "error",
            })
          })
        })
    },
  },
  watch: {
    selectedYear(newYear) {
      console.log("Year changed to:", newYear)
      // Ici on pourrait recharger les données pour la nouvelle année
    },
    canteenId() {
      this.canteen = this.canteenFromStore
    },
  },
}
</script>

<style scoped>
.chart-container {
  position: relative;
}

.chart-bar {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-radius: 4px 4px 0 0;
}

.chart-label {
  position: absolute;
  top: -25px;
  font-size: 12px;
  font-weight: bold;
  color: #666;
}

.h-100 {
  height: 100%;
}

.v-card {
  position: relative;
}

.v-card .v-btn {
  position: absolute;
  bottom: 16px;
  right: 16px;
}
</style>
